<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" class="bgImg" />
      <div>最新展位图</div>
    </div>
    <router-link to="/expoExhibitor">
      <img src="https://cdn.alighting.com/wxopen/cover/fenbu2024.jpg" class="fenbuImg" />
    </router-link>
    <div v-for="(item, index) in exhibitionList" :key="index">
      <div class="region" :class="{'region_b':index%2==0}" v-if="item.List.length>0">
        <div class="area"><span>{{item.Title}}</span></div>
        <div class="exh_list">
          <div v-for="(sitem, sindex) in item.List" :key="sindex">
            <div class="el_item" @click.stop="toShowRoom(sitem.HallNo)">
              <div>{{sitem.HallNoDesc}}</div>
              <div class="overFlowTwo">{{sitem.Desc}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { exhibitionList } from "@/api/index";
export default {
  name: "expoLatestBooth",
  data() {
    return {
      exhibitionList: [],
    };
  },
  computed: {},
  methods: {
    //跳转展馆
    toShowRoom(hallNo) {
      this.$router.push({ path: "/expoExhibitor", query: { hallNo: hallNo } });
    },
  },
  mounted() {
    exhibitionList({ IsOrder: 0 }).then((res) => {
      // 处理数据
      var elist = [
          {Title:"A区展馆",List:[]},
          {Title:"B区展馆",List:[]},
          {Title:"D区展馆",List:[]}];
      if(res.Data.List.length>0){
        res.Data.List.forEach(function(item, index){
          if(item.Region==1){
              elist[0].List.push(item)
          }else if(item.Region==2){
              elist[1].List.push(item)
          }else if(item.Region==3){
              elist[2].List.push(item)
          }else{}
        })
      }
      this.exhibitionList = elist;
    });
  },
};
</script>
<style scoped lang="less">
.top-box {
  width: 375px;
  height: 103px;
  position: relative;
  div {
    position: absolute;
    z-index: 1;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, 0);
    color: #fff;
    font-size: 23px;
    font-weight: bold;
  }
}

.bgImg {
  width: 100%;
  height: 100%;
}

.fenbuImg {
  display: block;
  width: 100%;
  border-bottom: 10px solid #f4f4f4;
}

.region {
  .area {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 0 25px 0;
    span {
      position: relative;
      font-size: 14px;
      font-weight: bold;
      color: #7b8294;
      &::before {
        display: block;
        content: "";
        position: absolute;
        z-index: 2;
        width: 50px;
        height: 1px;
        background-color: #cccccc;
        top: 50%;
        right: calc(100% + 7px);
      }
      &::after {
        display: block;
        content: "";
        position: absolute;
        z-index: 2;
        width: 50px;
        height: 1px;
        background-color: #cccccc;
        top: 50%;
        left: calc(100% + 7px);
      }
    }
  }
}

.exh_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 12px;
}

.el_item {
  width: 170px;
  padding: 0 13px 0 5px;
  box-sizing: border-box;
  height: 48px;
  background: #f4f4f4;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 9px;
  div:first-child {
    width: 35px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    background: #7b8294;
    border-radius: 17px;
    color: #fff;
    font-size: 12px;
  }
  div.overFlowTwo {
    width: 105px;
    font-size: 12px;
    color: #333333;
    line-height: 15px;
  }
}

.region_b {
  padding-bottom: 20px;
}

.region.region_b .area span {
  color: #b8757e;
}

.region_b .el_item {
  background-color: #f7f1f2;
}

.region_b .el_item > div:first-child {
  background: #b8757e;
}
</style>
